(function () {
  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  function getQuantity(root) {
    var input = root.querySelector('[data-obp-station-quantity-input]');
    var quantity = Number(root.dataset.obpStationQuantity || (input && input.value) || 1);
    return Math.max(1, Number.isFinite(quantity) ? quantity : 1);
  }

  function update(root, nextQuantity) {
    if (!root) return;

    var regular = Number(root.dataset.regularPrice || 3490);
    var additional = Number(root.dataset.additionalPrice || 2990);
    var quantity = Math.max(1, Math.min(20, Number(nextQuantity || 1)));
    var total = regular + Math.max(0, quantity - 1) * additional;
    var saving = Math.max(0, quantity - 1) * (regular - additional);
    var input = root.querySelector('[data-obp-station-quantity-input]');
    var output = root.querySelector('[data-obp-station-quantity-output]');
    var head = root.querySelector('[data-obp-station-head-price]');
    var price = root.querySelector('[data-obp-station-button-price]');
    var stickyPrice = root.querySelector('[data-obp-station-sticky-price]');
    var totalLabel = root.querySelector('[data-obp-station-total]');
    var breakdown = root.querySelector('[data-obp-station-breakdown]');
    var savingLabel = root.querySelector('[data-obp-station-saving]');
    var minus = root.querySelector('[data-obp-station-minus]');
    var plus = root.querySelector('[data-obp-station-plus]');

    root.dataset.obpStationQuantity = String(quantity);
    if (input) input.value = quantity;
    if (output) output.textContent = quantity;
    if (head) head.textContent = formatMoney(total);
    if (price) price.textContent = formatMoney(total);
    if (stickyPrice) stickyPrice.textContent = formatMoney(total);
    if (totalLabel) totalLabel.textContent = 'Gesamt ' + formatMoney(total);
    if (minus) minus.disabled = quantity <= 1;
    if (plus) plus.disabled = quantity >= 20;
    if (savingLabel) {
      savingLabel.textContent = 'Sie sparen ' + formatMoney(saving);
      savingLabel.classList.toggle('is-visible', saving > 0);
    }
    if (breakdown) {
      breakdown.textContent = quantity === 1
        ? '1 × Ladestation zu ' + formatMoney(regular)
        : '1 × ' + formatMoney(regular) + ' + ' + (quantity - 1) + ' × ' + formatMoney(additional);
    }

    root.querySelectorAll('[data-obp-station-offer]').forEach(function (offer) {
      var active = Number(offer.dataset.obpStationOffer) === quantity;
      offer.classList.toggle('is-selected', active);
      offer.setAttribute('aria-checked', String(active));
    });
  }

  async function addSelectedStations(root) {
    var form = root.querySelector('.obp-station__buy-form');
    var buyButton = root.querySelector('[data-obp-station-buy]');
    var errorWrapper = root.querySelector('.product-form__error-message-wrapper');
    var errorMessage = errorWrapper && errorWrapper.querySelector('.product-form__error-message');
    if (!form || !buyButton || buyButton.disabled || buyButton.classList.contains('loading')) return;

    var quantity = getQuantity(root);
    var regularVariantId = Number(root.dataset.regularVariantId);
    var extraVariantId = Number(root.dataset.extraVariantId);
    var extraAvailable = root.dataset.extraAvailable === 'true';
    if (!regularVariantId || (quantity > 1 && (!extraVariantId || !extraAvailable))) {
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = 'Die gewünschte Anzahl ist derzeit nicht verfügbar.';
        errorWrapper.hidden = false;
      }
      return;
    }

    var items = [{ id: regularVariantId, quantity: 1 }];
    if (quantity > 1) items.push({ id: extraVariantId, quantity: quantity - 1 });

    buyButton.classList.add('loading');
    buyButton.disabled = true;
    buyButton.setAttribute('aria-busy', 'true');
    if (errorWrapper) errorWrapper.hidden = true;

    try {
      var response = await fetch(window.theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: items })
      });
      var result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Die Ladestation konnte nicht hinzugefügt werden.');
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: { product: result.items?.[0] || result }
      }));
      window.setTimeout(function () { document.getElementById('Cart-Drawer')?.open(); }, 100);
    } catch (error) {
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = error.message || 'Bitte versuchen Sie es erneut.';
        errorWrapper.hidden = false;
      }
    } finally {
      buyButton.classList.remove('loading');
      buyButton.disabled = false;
      buyButton.removeAttribute('aria-busy');
    }
  }

  function handleClick(event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var control = target.closest(
      '[data-obp-station-offer], [data-obp-station-minus], [data-obp-station-plus], [data-obp-station-scroll], [data-obp-station-sticky-submit]'
    );
    if (!control) return;

    var root = control.closest('[data-obp-station]');
    if (!root) return;

    if (control.matches('[data-obp-station-offer]')) {
      update(root, Number(control.dataset.obpStationOffer || 1));
      return;
    }

    if (control.matches('[data-obp-station-minus]')) {
      update(root, getQuantity(root) - 1);
      return;
    }

    if (control.matches('[data-obp-station-plus]')) {
      update(root, getQuantity(root) + 1);
      return;
    }

    if (control.matches('[data-obp-station-scroll]')) {
      var hero = root.querySelector('#bestellen');
      if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    if (control.matches('[data-obp-station-sticky-submit]')) {
      addSelectedStations(root);
    }
  }

  function init(root) {
    if (!root || root.dataset.obpStationReady === 'true') return;
    root.dataset.obpStationReady = 'true';
    update(root, getQuantity(root));

    var form = root.querySelector('.obp-station__buy-form');
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addSelectedStations(root);
      });
    }

    var hero = root.querySelector('#bestellen');
    var sticky = root.querySelector('[data-obp-station-sticky]');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && window.innerWidth <= 640;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (show) sticky.removeAttribute('inert');
        else sticky.setAttribute('inert', '');
      }, { threshold: 0.08 });
      observer.observe(hero);
    }
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-obp-station]').forEach(init);
  }

  if (!window.__obpStationV2ControlsReady) {
    window.__obpStationV2ControlsReady = true;
    document.addEventListener('click', handleClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
